import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-734">
      <PriceAlert data-id="element-735" />
      <Hero data-id="element-736" />
      <Testimonial data-id="element-737" />
      <ProblemSolution data-id="element-738" />
      <ValueStack data-id="element-739" />
      <ModuleBreakdown data-id="element-740" />
      <Guarantee data-id="element-741" />
      <PricingSection data-id="element-742" />
      <Footer data-id="element-743" />
      <RecentPurchaseToast data-id="element-744" />
    </div>;
}